import store from "../../../store"
import { axiosWrapper } from "../../axios_old"
import { Display, formatDate, getCurrency } from "../../formating"
import preparePayload from "../preparePayload"

const recurringContribution = async (args) => {
	const { user, data, action, setNotification, stitchingData, history } = args
	try {
		let newData = {}
		if (action === "GET_ALL") {
			const { data: recurringContributionAPI } = await axiosWrapper(
				"GET",
				"contribution/recurring?includeBankAccount=true",
				null,
				null,
				user.token
			)

			const recurringContributions = new Map()

			recurringContributionAPI.forEach((c) => {
				const { fundingSource, recurrence } = c
				recurringContributions.set(c.id, {
					...c,
					tableGroup: "recurring",
					fundingSource,
					tableValues: {
						date: formatDate({
							data: c.nextTs,
							actions: ["display"]
						}),
						fundingSource: Display.FundingSource({
							fundingSource,
							isRecurring: true,
							recurrence
						}),
						amount: getCurrency({
							amount: c.amount,
							actions: ["divide"]
						})
					}
				})
			})
			return recurringContributions
		} else if (action === "GET_ONE") {
			const { data: recurringContributionAPI } = await axiosWrapper(
				"GET",
				"contribution/recurring",
				null,
				null,
				user.token
			)

			const recurringContribution = recurringContributionAPI.find((c) => c.id === data.id)
			const fundingSource =
				recurringContribution.fundingSource === "saveAsYouGo"
					? recurringContribution.fundingSource
					: stitchingData.bankAccounts.get(recurringContribution.fundingSource)

			return {
				...recurringContribution,
				tableGroup: "recurring",
				fundingSource,
				tableValues: {
					date: formatDate({
						data: recurringContribution.nextTs + 86400000,
						actions: ["display"]
					}),
					fundingSource: Display.FundingSource({
						fundingSource,
						isRecurring: true,
						recurrence: recurringContribution.recurrence
					}),
					amount: getCurrency({
						amount: recurringContribution.amount,
						actions: ["divide"]
					})
				}
			}
		} else if (action === "CREATE") {
			newData = await preparePayload({
				user,
				schema: "recurringContribution",
				data,
				url: "contribution/recurring"
			})
			await store.setNotification("notification", true, {
				msg: `Successfully created recurring contribution for ${getCurrency({
					amount: data?.amount,
					actions: ["divide"]
				})} from ${data?.fundingSourceObj?.nickname}`,
				severity: "success",
				isPersist: true
			})
		} else if (action === "UPDATE") {
			newData = await preparePayload({
				user,
				schema: "recurringContribution",
				data,
				url: `contribution/recurring/${data.id}`
			})
			await store.setNotification("notification", true, {
				msg: `Successfully updated recurring contribution for ${getCurrency({
					amount: data?.amount,
					actions: ["divide"]
				})} from ${data?.fundingSourceObj?.nickname}`,
				severity: "success",
				isPersist: true
			})
		} else if (action === "DELETE") {
			await axiosWrapper(`DELETE`, `contribution/recurring/${data.id}`, null, null, user.token)

			await store.setNotification("notification", true, {
				msg: `Successfully removed recurring contribution for ${getCurrency({
					amount: data?.amount,
					actions: ["divide"]
				})} from ${data?.fundingSource?.nickname}.`,
				severity: "success",
				isPersist: true
			})
		}

		if (history) {
			history(-1)
		}

		return newData
	} catch (err) {
		console.error(err)
		if (setNotification) {
			await setNotification("notification", true, {
				msg: err?.response?.data?.message,
				severity: "error"
			})
		}
	}
}

export default recurringContribution
